import * as ReachAlertDialog from '@reach/alert-dialog';
import classNames from 'classnames';
import { type ComponentProps, memo } from 'react';

export type AlertModalDescriptionProps = ReachAlertDialog.AlertDialogLabelProps & Omit<ComponentProps<'div'>, 'ref'>;

export const AlertModalDescription = memo(({ className, ...restOfProps }: AlertModalDescriptionProps) => {
  return (
    <ReachAlertDialog.AlertDialogDescription
      className={classNames('ads:text-secondary text-16 text-gray-11', className)}
      {...restOfProps}
    />
  );
});

AlertModalDescription.displayName = 'AlertModalDescription';
